import { LoadingModule } from '../loading/loading.module';
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {CommonModule} from '@angular/common';
import { ResearchProjectsDetailsComponent } from './research-projects-details.component';
import { ResearchProjectsDetailsRoutingModule } from './research-projects-details-routing.module';
@NgModule({
  imports: [
    ResearchProjectsDetailsRoutingModule,
    HttpClientModule,
    CommonModule,
    LoadingModule
  ],
  declarations: [ResearchProjectsDetailsComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class ResearchProjectsDetailsModule { }
